import React from 'react'
import styled from '@emotion/styled'

import {Box} from '@vio/atlas/helpers/Box'
import {Tag} from '@vio/atlas/src/components/designSystem/Tag'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

// hax for keeping the single line room name centered with tag which has different height
const HeightMatchingTag = styled(Box)`
  min-height: 32px;
`

const RoomMultiplier = ({numberOfRooms}: {numberOfRooms: number}) => {
  return (
    <Tag variant="neutralOutline" size="md" dataId="roomTitle.multiplier">
      <FormattedMessageWrapper
        id="roomTitle.multiplier"
        defaultMessage="{numberOfRooms}x"
        values={{numberOfRooms}}
      />
    </Tag>
  )
}

export const RoomNameWithMultiplier = ({
  roomNameSlot,
  numberOfRooms
}: {
  roomNameSlot: React.ReactNode
  numberOfRooms: number
}) => {
  return (
    <Box display="flex" alignItems="flex-start" gap="s300">
      <RoomMultiplier numberOfRooms={numberOfRooms} />
      <HeightMatchingTag display="flex" alignItems="center">
        {roomNameSlot}
      </HeightMatchingTag>
    </Box>
  )
}
